export default "__VITE_ASSET__bVeG5tgy__"